import React from "react"

import { FooterProps } from "./common"
import DesktopFooter from "./DesktopFooter"
import MobileFooter from "./MobileFooter"
import TabletFooter from "./TabletFooter"

const Footer: React.FC<FooterProps> = (props) => {
  return (
    <>
      <MobileFooter {...props} />
      <TabletFooter {...props} />
      <DesktopFooter {...props} />
    </>
  )
}

export default Footer
